import { Avatar, Button, Link, Typography, alpha } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import { Teacher } from "@app/shared/types";
import TeacherDialog from "features/community/TeacherDialog";
import { externalImageSrc } from "app/images";
import { useState } from "react";

const useStyles = makeStyles((theme) => ({
    contentWrapper: {
        display: "flex",
        position: "relative",
        borderRadius: theme.borderRadius.default,
        padding: theme.spacing(4),
        background: alpha(theme.palette.grey700, 0.1),
        [theme.breakpoints.down("md")]: {
            flexDirection: "column",
            textAlign: "center",
        },
    },
    avatar: {
        width: 260,
        height: 260,
        marginRight: theme.spacing(10),
        cursor: "pointer",
        [theme.breakpoints.down("md")]: {
            margin: "auto",
            marginBottom: theme.spacing(2),
        },
        [theme.breakpoints.down("sm")]: {
            width: 154,
            height: 154,
        },
    },
    content: {
        width: "100%",
    },
    teacherName: {},
    teacherBio: {},
}));

export const TeacherBioCard = (props: { teacher: Teacher }): JSX.Element => {
    const classes = useStyles();
    // const [teacherDialogOpen, setTeacherDialogOpen] = React.useState(false);

    const { teacher } = props;

    const [teacherDialogOpen, setTeacherDialogOpen] = useState(false);

    return (
        <div className={classes.contentWrapper}>
            <Avatar
                data-testid="teacherAvatar"
                className={classes.avatar}
                alt={teacher.name}
                src={teacher.picture ? externalImageSrc(teacher.picture, 260) : "EMPTY"}
                variant="circular"
                onClick={() => setTeacherDialogOpen(true)}
            />

            <div className={classes.content}>
                <Typography variant="h4" className={classes.teacherName}>
                    {teacher.name}
                </Typography>

                <Typography variant="body1" className={classes.teacherBio}>
                    {teacher.shortBio ?? teacher.background}
                </Typography>

                <Button variant="tertiary" onClick={() => setTeacherDialogOpen(true)}>
                    Know more
                </Button>

                <TeacherDialog
                    open={teacherDialogOpen}
                    onClose={() => setTeacherDialogOpen(false)}
                    teacher={teacher}
                />
            </div>
        </div>
    );
};
